import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

class View extends PureComponent {
  render() {
    const { student, grade, birthday } = this.props;
    const formatDateString = (dateString) => {
      const date = new Date(dateString);
      return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
    };

    const getIsEmpty = (x) => {
      return x === undefined || x === null || x === '' ? 'empty' : undefined;
    };
    return (
      <table className="responsive">
        <thead>
          <tr>
            <th colSpan="2">参加者様情報</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>参加者氏名</th>
            <td>
              <span>
                {student.last_name}
                {' '}
                {student.first_name}
              </span>
            </td>
          </tr>
          <tr>
            <th>フリガナ</th>
            <td>
              <span>
                {student.last_name_kana}
                {' '}
                {student.first_name_kana}
              </span>
            </td>
          </tr>
          <tr>
            <th>生年月日</th>
            <td><span>{formatDateString(birthday)}</span></td>
          </tr>
          <tr>
            <th>学年</th>
            <td><span>{grade}</span></td>
          </tr>
          <tr>
            <th>学校名</th>
            <td><span>{student.school_name}</span></td>
          </tr>
          <tr>
            <th>参加者様携帯番号</th>
            <td><span>{student.phone}</span></td>
          </tr>
          {student.other_health !== undefined && (
            <>
              <tr>
                <th>アレルギー情報</th>
                <td><span className={getIsEmpty(student.allergy_info)}>{student.allergy_info}</span></td>
              </tr>
              <tr>
                <th>服薬・その他健康面について</th>
                <td><span className={getIsEmpty(student.other_health)}>{student.other_health}</span></td>
              </tr>
            </>
          )}
        </tbody>
      </table>
    );
  }
}

View.propTypes = {
  student: PropTypes.shape({
    last_name: PropTypes.string.isRequired,
    first_name: PropTypes.string.isRequired,
    last_name_kana: PropTypes.string.isRequired,
    first_name_kana: PropTypes.string.isRequired,
    school_name: PropTypes.string.isRequired,
    phone: PropTypes.string.isRequired,
    allergy_info: PropTypes.string,
    other_health: PropTypes.string,
  }).isRequired,
  birthday: PropTypes.string.isRequired,
  grade: PropTypes.string.isRequired,
};

export default connect()(View);
